import React from 'react';
import { NewTripRequest } from '../../types';

interface StepProps {
  formData: NewTripRequest;
  setFormData: React.Dispatch<React.SetStateAction<NewTripRequest>>;
}

const StepInterestsPace: React.FC<StepProps> = ({ formData, setFormData }) => {
  
  // Expanded list of interests
  const interests = [
    'Culture & History', 'Food & Dining', 'Adventure & Outdoor', 'Art & Museums',
    'Nature & Wildlife', 'Nightlife & Entertainment', 'Shopping', 'Photography',
    'Relaxation & Wellness', 'Sports & Activities', 'Architecture', 'Music & Events',
    'Local Festivals', 'Hidden Gems', 'Romantic Spots', 'Family Fun',
    'Luxury Experiences', 'Budget Friendly', 'Hiking & Trekking', 'Beach & Water',
    'Urban Exploration', 'Rural Escapes', 'Historical Landmarks', 'Culinary Tours'
  ];

  const toggleInterest = (interest: string) => {
    if (formData.interests.includes(interest)) {
      setFormData(prev => ({
        ...prev,
        interests: prev.interests.filter(i => i !== interest)
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        interests: [...prev.interests, interest]
      }));
    }
  };

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      
      {/* Travel Pace */}
      <div className="space-y-4">
        <h3 className="text-lg font-medium text-gray-900">What's your preferred travel pace?</h3>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
           {['relaxed', 'moderate', 'fast-paced'].map((paceOption) => (
             <button
                key={paceOption}
                type="button"
                onClick={() => setFormData(prev => ({ ...prev, pace: paceOption }))}
                className={`p-4 rounded-xl border-2 text-left transition-all ${
                    formData.pace === paceOption 
                    ? 'border-primary-500 bg-primary-50 text-primary-900 shadow-md' 
                    : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50 text-gray-600'
                }`}
             >
                <div className="font-semibold capitalize mb-1">{paceOption}</div>
                <div className="text-xs opacity-80">
                    {paceOption === 'relaxed' && 'Take it easy, fewer stops.'}
                    {paceOption === 'moderate' && 'Balanced mix of sights and rest.'}
                    {paceOption === 'fast-paced' && 'See as much as possible!'}
                </div>
             </button>
           ))}
        </div>
      </div>

      <div className="border-t border-gray-100 pt-4"></div>

      {/* Interests */}
      <div className="space-y-4">
        <h3 className="text-lg font-medium text-gray-900">What are you interested in?</h3>
        <p className="text-sm text-gray-500">Select all that apply to help us personalize your itinerary.</p>
        
        <div className="flex flex-wrap gap-2">
            {interests.map((interest) => (
                <button
                    key={interest}
                    type="button"
                    onClick={() => toggleInterest(interest)}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all transform hover:scale-105 ${
                        formData.interests.includes(interest)
                        ? 'bg-primary-600 text-white shadow-md'
                        : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                    }`}
                >
                    {interest}
                </button>
            ))}
        </div>
      </div>

    </div>
  );
};

export default StepInterestsPace;

